// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"ede6c6e098b16ee8392f","339":"a75caebddefcfb914480"}[chunkId] + ".js";
};